module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJf44Os44Kk44Ok44O8XzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDM5LjUgMzkuNSI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMwMDA7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjRweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9Il/jg6zjgqTjg6Tjg7xfMS0yIj48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIxLjQxIiB5MT0iMS40MSIgeDI9IjM4LjA5IiB5Mj0iMzguMDkiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSIxLjQxIiB5MT0iMzguMDkiIHgyPSIzOC4wOSIgeTI9IjEuNDEiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/model/close_icon.svg
// module id = XiFy
// module chunks = 0